<template>
  <div class="MissionArchiveDetails">
    <v-dialog v-model="visible">
      <box :title="$t('missionDetails')">
        <v-row class="pa-2">
          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("PageNo") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.PageNo }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestedPersonName") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.PersonName }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("BeginDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.BeginDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("BeginTime") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.BeginTime }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("EndDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.EndDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("EndTime") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.EndTime }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("cityName") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.CityName }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("missionLocation") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.Location }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("requestType") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.Name }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("LastChangeDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.LastChangeDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="3">{{ $t("status") }}:</v-col>
              <v-col cols="9">
                <span
                  class="text-value"
                  v-text="
                    item.StatusType +
                    '-' +
                    (details.IsTransfer
                      ? 'انتقال داده شده'
                      : 'انتقال داده نشده')
                  "
                ></span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="3">{{ $t("description") }}:</v-col>
              <v-col cols="9">
                <span class="text-value">
                  {{ details.PersonName }}:{{ details.UserDescription }} <br />
                  <span
                    >تائید / رد کننده: {{ ApprovedPerson }}
                    {{ details.RejectCommand }}</span
                  >
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card class="ma-2">
          <v-data-table
            v-if="rdGridTimesVisible"
            :items="missionHourList"
            :headers="missionHourHeader"
            disable-pagination
            disable-sort
            hide-default-footer
            dense
          />
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn small v-if="visibleReturn" @click="ReturnRequest">{{
            $t("ReturnRequest")
          }}</v-btn>
          <v-btn small v-if="visibleReject" @click="RejectRequest">{{
            $t("RejectRequest")
          }}</v-btn>
          <v-btn small v-if="visibleApprove" @click="ApproveRequest">{{
            $t("ApproveRequest")
          }}</v-btn>
          <v-btn small v-if="visibleDelete" @click="DeleteRequest">{{
            $t("DeleteRequest")
          }}</v-btn>
          <v-btn small v-if="visibleEdit" @click="EditRequest">{{
            $t("EditRequest")
          }}</v-btn>
        </v-card-actions>

        <archive-detals-flow
          :pageNo="pageNo"
          :pageType="2"
          :year="Number(item.Year)"
        />
      </box>
      
    </v-dialog>
  </div>
</template>

<script>
import RequestState from "@/model/RequestState";
import ArchiveDetalsFlow from "../../request/ArchiveDetalsFlow.vue";
import TextUtils from "../../../utils/TextUtils";
import ResultType from "../../../model/ResultType";
import EosUtils from "../../../utils/EosUtils";
import i18n from '../../../i18n'

const initialData = () => {
  return {
      visible: false,
      item: {},
      details: {},
      visibleEdit: false,
      visibleDelete: false,
      visibleReject: false,
      visibleReturn: false,
      visibleApprove: false,
      ApprovedPerson: "",
      rdGridTimesVisible: false,
      missionHourList: [],
      missionHourHeader: [
        {
          text: i18n.t("date"),
          value: "BeginDate",
        },
        {
          text: i18n.t("DayName"),
          value: "DayName",
        },
        {
          text: i18n.t("BeginTime"),
          value: "beginTime",
        },
        {
          text: i18n.t("EndTime"),
          value: "EndTime",
        },
      ],
    };
};

export default {
  components: { ArchiveDetalsFlow },
  computed: {
    pageNo() {
      if (this.item && this.item.Pageno) {
        return this.item.Pageno.toString().trim();
      } else {
        return "";
      }
    },
  },
  props: {},
  data() {
    return initialData();
  },
  methods: {
    resetData() {
      Object.assign(this.$data, initialData());
    },
    show(item) {
      this.resetData();
      this.visible = true;
      this.item = item;
      this.GetMissionDetailForPerson(this.item);
    },
    hide() {
      this.visible = false;
    },
    GetMissionDetailForPerson(item) {
      const params = new URLSearchParams();
      params.append("pageNo", TextUtils.convertToEnglishDigits(item.Pageno));
      params.append("dbkind", "1");
      params.append("year", item.Year);
      params.append("perno", TextUtils.convertToEnglishDigits(item.Perno));

      this.$store
        .dispatch("GetMissionDetailForPerson", { params })
        .then((result) => {
          if (result.type == "success") {
            if (result.data.length > 0) {
              this.details = result.data[0];
              this.checkActionsVisiblity();
              this.getApprovedPerson();
              this.GetMissionHourForMission(this.details);
            }
          }
        });
    },
    GetMissionHourForMission(item) {
      this.missionHourList = [];
      if (item.IsDaily) {
        this.rdGridTimesVisible = true;
        var GetMissionHourForMissionParams = {
          pageNo: TextUtils.convertToEnglishDigits(this.item.Pageno),
          year: this.item.Year,
          dbKind:1
        };
        this.$store
          .dispatch("GetMissionHourForMission", {
            GetMissionHourForMissionParams,
          })
          .then((result) => {
            if (result.type == ResultType.success) {
              this.missionHourList = result.data;
            }
          });
      } else {
        this.rdGridTimesVisible = false;
      }
    },
    getApprovedPerson() {
      if (this.details.ApprovedPerson.trim() == "-1") {
        this.ApprovedPerson = this.$t("webkartManager");
      } else if (this.details.ApprovedPerson.trim() == "000") {
        this.ApprovedPerson = this.$t("winkartManager");
      } else {
        let params = new URLSearchParams();
        params.append("perno", this.details.ApprovedPerson.trim());
        this.$store.dispatch("GetPersonFullName", { params }).then((result) => {
          if (result.type === ResultType.success) {
            this.ApprovedPerson = result.data;
          }
        });
      }
    },
    checkActionsVisiblity() {
      var params = new URLSearchParams();
      params.append(
        "pagePerno",
        TextUtils.convertToEnglishDigits(this.item.Pageno.trim())
      );
      params.append(
        "section",
        TextUtils.convertToEnglishDigits(this.item.Section.trim())
      );
      params.append("missionType", this.item.Type);
      params.append("status", this.item.Status);
      this.$store
        .dispatch("GetMissionDetailForAdmin", { params })
        .then((result) => {
          if (result.type === ResultType.success) {
            this.visibleEdit = result.data.Edit;
            this.visibleDelete = result.data.Delete;
            this.visibleReject = result.data.Reject;
            this.visibleReturn = result.data.Return;
            this.visibleApprove = result.data.Approve;
          }
        });
    },
    EditRequest() {
      this.hide();
      //console.log(this.details);
      //console.log(this.item);

      var itemDetails = {
        Year: this.item.Year,
        PageNo: this.details.Pageno,
        Type: this.details.Type,
      };

      if (EosUtils.isWebKartAdmin()) {
        this.$router.push({
          name: "admin-request-mission",
          params: { details: itemDetails },
        });
      }
    },
    DeleteRequest() {
      this.operationOnRequest(RequestState.RequestState.Delete);
    },
    ReturnRequest() {
      this.operationOnRequest(RequestState.RequestState.Return);
    },
    RejectRequest() {
      this.operationOnRequest(RequestState.RequestState.Reject);
    },
    ApproveRequest() {
      this.operationOnRequest(RequestState.RequestState.Approve);
    },
    operationOnRequest(requestState) {
      var list = [this.item];
      this.$emit("operationOnRequest", requestState, list);
      this.hide();
    },
  },
};
</script>

<style scoped>
*td {
  padding: 2px;
}
</style>